import currentRouteObj from 'root/src/client/logic/route/selectors/currentRouteObj'
import setSession from 'root/src/client/logic/auth/util/setSession'
import authSelector from 'root/src/client/logic/auth/util/authSelector'
import determineAuth from 'root/src/client/logic/auth/thunks/determineAuth'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'
import authApi from 'root/src/shared/util/authApi'
import { getDefaultRoute } from 'root/src/client/logic/auth/util/getDefaultRoute'

export default ({ password }) => async (dispatch, getState) => {
	const state = getState()
	const { query } = currentRouteObj(state)

	if (!query?.token) {
		throw new Error('There\'s no token')
	}

	const body = await authApi.setAccountCredentials({ token: query.token, password })

	setSession(authSelector(body))
	await dispatch(determineAuth())
	const defaultRoute = await getDefaultRoute({ dispatch, getState })
	return pushRouteClient(defaultRoute)
}
